<template>
  <div id="all">
    <!-- <h3>按条件搜索人才列表</h3> -->
    <!-- 搜索 -->
    <!-- <Select @search="search" @reset="reset"/> -->
    <!-- 操作 -->
    <!-- <h3>审批通知</h3> -->
    <div class="content">
      <div class="title">
        <div class="box"><span>所有通知</span></div>
      </div>
      <div class="messagebox">
        <div class="message" v-for="(item,index) in message" :key="index">
          <div class="messagetime">{{ item.time }}</div>
          <div class="messagecontent">{{ item.content }}</div>
        </div>
      </div>
      <div class="pagination ">
        <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        >>
      </el-pagination>
      </div>
    </div>
  </div>
</template>
  
<script>
import { getMyCaseApi } from "../../api/case";
// import Select from "../../components/case/Select.vue";
export default {
  name: "notice",
  data() {
    return {
      message: [
        {
          time:'2023-05-23 14:23',
          content:'案件股东损害债权人利益责任纠纷（2018）苏0507民初4064号提醒您审核'
        },
        {
          time:'2023-05-23 14:23',
          content:'案件股东损害债权人利益责任纠纷（2018）苏0507民初4064号提醒您审核'
        },
        {
          time:'2023-05-23 14:23',
          content:'案件股东损害债权人利益责任纠纷（2018）苏0507民初4064号提醒您审核'
        }
      ],
      currentPage: 1,
      pageSize: 5,
    };
  },
  created() {

  },
  components: {
  },
  methods: {
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
    },
  },
  computed:{
    total() {
      return this.message.length
      // return 9
    }
  }
};
</script>
  
<style lang="less" scoped>
.content {
  width: 100%;
  height: 926px;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 16px;
  .title {
    width: 100%;
    height: 50px;
    border-bottom: 1px solid #EEEFF2;
    .box {
      width: 80px;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 20px;
      color: #3077E6;
      font-weight: bold;
      text-align: center;
      box-sizing: border-box;
      border-bottom: 2px solid #3077E6;
    }
  }
  .messagebox{
    width: 96%;
    margin: 0 auto;
    .message{
      height: 60px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      // margin-top: 20px;
      padding: 20px 0;
      border-bottom: 1px solid #EEEFF2;
      .messagetime{
        font-size: 14px;
        color: #666666;
      }
    }
  }
  .pagination{
    position: fixed;
    bottom: 40px;
    right: 80px;
    .el-pagination{
      padding-right: 50px;

    }
  }
}
</style>